import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import GameThumb from '~/client/shared/game/GameThumb';
import NextLink from '~/client/shared/NextLink';
import TextTrimmer from '~/client/shared/TextTrimmer';
import trackEvent from '~/shared/trackEvent';
import ItemDivider from '../../../ItemDivider';
import FavouriteToggle from '../../FavouriteToggle';
import GameProvider from '../../GameCard/GameInfo/GameProvider';

type Props = {
  game: GameFragment;
  href?: string;
};

const GameListItem: FC<Props> = ({ game, href }) => {
  const trackGtm = () => trackEvent({ gameName: game.name }, 'navigateToGame');
  const isLoggedIn = useIsLoggedIn();

  return (
    <>
      <div
        className="grid grid-flow-col grid-cols-[100px_minmax(1px,1fr)] gap-2"
        onClick={trackGtm}
      >
        <GameThumb
          game={game}
          width={90}
          height={66}
          isHoverEnabled
          hideFavourite
          href={href}
        />
        <NextLink href={href ?? game.href ?? ''}>
          <div className="grid grid-cols-minmax content-start gap-0">
            <TextTrimmer>
              <p className="text-moon-16 font-semibold">{game.name}</p>
            </TextTrimmer>
            <GameProvider game={game} />
          </div>
        </NextLink>
        {isLoggedIn && <FavouriteToggle game={game} />}
      </div>
      <ItemDivider />
    </>
  );
};

export default GameListItem;
